import LessonManagement from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/12-Settings/CogSquare'
import TechSupport from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/12-Settings/Wench'
import Calendar from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/21-Date-Calendar/Calendar1'
import TargetPath from '@berlitz/streamline-icons/lib/regular/06-Business-Products/04-Strategy/TargetPath'
import MyCourse from '@berlitz/streamline-icons/lib/regular/07-Work-Office-Companies/05-Tasks/TaskListEdit'
import Billing from '@berlitz/streamline-icons/lib/regular/08-Money-Payments-Finance/01-Accounting-Billing/AccountingInvoice'
import BookCloseBookmark1 from '@berlitz/streamline-icons/lib/regular/11-Content/02-Books/BookCloseBookmark1'
import Feedback from '@berlitz/streamline-icons/lib/regular/21-Messages-Chat-Smileys/02-Messages-Speech-Bubbles/MessagesBubbleWarning'
import Star from '@berlitz/streamline-icons/lib/regular/22-Social-Medias-Rewards-Rating/06-Rating/RatingStar'
import Instructor from '@berlitz/streamline-icons/lib/regular/36-School-Learning/01-School/SchoolTeacher'
import { StoreProps } from '@interfaces/StoreState'
import * as React from 'react'
import { useSelector } from 'react-redux'
import IconWrapper from '../../components/IconWrapper'
import { IconBg } from './ContactUs/style'

const MyLessonIcon = () => {
  const useV2 = useSelector(({ permissions }: StoreProps) => permissions.permissions['flag::Support-ContactUsV2']?.show)
  return useV2 ? <Calendar /> : <LessonManagement />
}

const InstructorIcon = () => {
  const useV2 = useSelector(({ permissions }: StoreProps) => permissions.permissions['flag::Support-ContactUsV2']?.show)
  return useV2 ? <BookCloseBookmark1 /> : <Instructor />
}

export const mappedIcons = {
  'instructor experience': [Instructor, true, 'green'],
  'instructor resources': [InstructorIcon, true, 'warning'],
  feedback: [Feedback, true, 'purple'],
  'technical support': [TechSupport, false, 'red'],
  'special request': [Star, true, 'info'],
  'special requests': [MyCourse, true, 'green'],
  billing: [Billing, true, 'green'],
  payment: [Billing, true, 'green'],
  payments: [Billing, true, 'green'],
  'lesson management': [LessonManagement, false, 'blue'],
  'my lessons': [LessonManagement, false, 'blue'],
  'my lesson': [MyLessonIcon, false, 'info'],
  'my course': [MyCourse, false, 'warning'],
  'my learning': [TargetPath, false, 'purple'],
  'my calendar': [Calendar, false, 'info'],
}

interface IconMappingProps {
  icon?: string
}

const IconMapping: React.FunctionComponent<IconMappingProps> = ({ icon }) => {
  let currentIcon = mappedIcons.feedback[0]
  let iconWeight = mappedIcons.feedback[1]
  let color = mappedIcons.feedback[2]

  const current = icon && mappedIcons[icon.toLowerCase()]

  if (current) {
    currentIcon = current[0]
    iconWeight = current[1]
    color = current[2]
  }

  return (
    <IconWrapper filled={iconWeight}>
      <IconBg color={color}>{React.createElement(currentIcon, {})}</IconBg>
    </IconWrapper>
  )
}

export default IconMapping
